// testing
// const eventStartDate = new Date('2026-04-07T08:00:00+08:00')
// const eventEndDate = new Date('2026-05-04T23:59:59+08:00')

// prod
export const eventStartDate = new Date('2026-04-21T10:00:00+08:00')
export const eventEndDate = new Date('2026-05-05T10:00:00+08:00')

const itemTypeIdByEnv = {
  production: 72,
  staging: 73,
  dev: 0, // TODO:
  development: 0,
} as Record<string, number>

export const itemTypeId = itemTypeIdByEnv[import.meta.env.MODE]
